'use client';

import React, {FC} from 'react';
import {datadogLogs} from '@datadog/browser-logs';
import {datadogRum} from '@datadog/browser-rum';

import {ErrorBoundary as Boundary, ErrorBoundaryProps} from '@zoefin/utils';

import {useDataLayer} from '@/stores/DataLayerContext';

interface BoundaryProps
  extends Omit<ErrorBoundaryProps, 'environment' | 'captureException'> {
  error?: ErrorBoundaryProps['error'];
}

const ErrorBoundary: FC<BoundaryProps> = ({error, children}) => {
  const {addToDataLayer} = useDataLayer();

  const logErrorEvent = async () => {
    addToDataLayer('renderingError');
    datadogRum.addAction('renderingError');
  };

  const handleException = (exceptionError: any) => {
    datadogLogs.logger.error(
      exceptionError.message,
      {tags: ['_app-capture-exception']},
      exceptionError,
    );

    logErrorEvent();
  };

  return (
    <Boundary
      captureException={handleException}
      environment={process.env.VERCEL_ENV}
      error={error}>
      {children}
    </Boundary>
  );
};

export default ErrorBoundary;
